import { Routes } from "@angular/router";
import { AppComponent } from "./app.component";
import { authGuardFn } from "./shared/auth/auth.guard";
import { routeList } from "./shared/models";
import { CompleteComponent } from "./complete/complete.component";

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    canActivate: [authGuardFn],
    component: AppComponent,
  },
  {
    path: `${routeList.agent.path}`,
    loadChildren: () =>
      import("./agent/agent-routing.module").then((m) => m.AgentRoutingModule),
  },
  {
    path: `${routeList.application.path}`,
    loadChildren: () =>
      import("./application/application-routing.module").then(
        (m) => m.ApplicationRoutingModule
      ),
  },
  {
    path: `${routeList.complete}`,
    component: CompleteComponent,
  },
  // // TODO: enable again after fixing the routing
  // { path: "**", component: PageNotFoundComponent },
];
